import {
  Form,
  FormCheckbox,
  FormRadio,
  FormRadioGroup,
  FormSubmit,
} from '@ariakit/react';
import {
  Button,
  Card,
  CardBody,
  CardImage,
  Checkbox,
  Content,
  getHeadingTag,
  Heading,
  InputField,
  InputMessage,
  Radio,
} from '@wienenergiegithub/ui-next';
import styles from './RaffleForm.module.scss';
import React from 'react';
import PropTypes from 'prop-types';

const RaffleForm = ({
  formContent,
  headingLevel,
  introImage,
  legalLabel,
  legalText,
  store,
}) => (
  <Form store={store}>
    <Card className={styles.card}>
      <CardImage
        aspectRatio={0.49}
        image={{
          ...introImage,
          ...{
            src: introImage.url,
            alt: introImage.alt || introImage.title,
          },
        }}
      />
      <CardBody>
        <Heading as={getHeadingTag(headingLevel)} size="h4">
          Danke fürs Mitmachen!
        </Heading>
        {formContent && <Content withParser>{formContent}</Content>}
        <FormRadioGroup className={styles.salutationWrapper} name="anrede">
          <FormRadio
            name="anrede"
            render={<Radio label="Frau" />}
            value="female"
            variant="horizontal"
          />
          <FormRadio
            name="anrede"
            render={<Radio label="Herr" />}
            value="male"
            variant="horizontal"
          />
          <FormRadio
            name="anrede"
            render={<Radio label="Divers" />}
            value="non-binary"
            variant="horizontal"
          />
        </FormRadioGroup>
        <div className={styles.inputWrapper}>
          <InputField
            label="Vorname"
            name="vorname"
            store={store}
            variant="closed"
          />
          <InputField
            label="Nachname"
            name="nachname"
            store={store}
            variant="closed"
          />
          <InputField
            label="E-Mail"
            name="email"
            store={store}
            type="email"
            variant="closed"
          />
          <InputField
            label="Telefon"
            name="telefon"
            store={store}
            variant="closed"
          />
        </div>
        <InputMessage name="topics" store={store} />
        <FormCheckbox
          className={styles.acceptedCheckbox}
          name="accepted"
          render={
            <Checkbox
              label={
                <Content noSpacing withParser>
                  {legalLabel}
                </Content>
              }
            />
          }
        />
        <InputMessage name="accepted" store={store} />
        <Content className={styles.legalText} noSpacing withParser>
          {legalText}
        </Content>
        <FormSubmit
          className={styles.button}
          render={<Button isElevated />}
          store={store}
          type="submit"
        >
          Abschicken
        </FormSubmit>
      </CardBody>
    </Card>
  </Form>
);

RaffleForm.propTypes = {
  formContent: PropTypes.string,
  headingLevel: PropTypes.number,
  introImage: PropTypes.shape({
    alt: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  legalLabel: PropTypes.string,
  legalText: PropTypes.string,
  /* eslint-disable react/forbid-prop-types */
  store: PropTypes.object,
};

export default RaffleForm;
